export default {
    'Musical Theatre Ltd. Charity Gala Dinner & Asia Pacific Grand Art Exhibition 2022': [
        'WhatsApp Video 2022-07-01 at 10.40.50 PM.mp4',
        'WhatsApp Image 2022-06-30 at 10.36.59 PM (1).jpeg',
        'WhatsApp Image 2022-06-30 at 10.36.59 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.37.00 PM (1).jpeg',
        'WhatsApp Image 2022-06-30 at 10.37.00 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.37.01 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.37.02 PM (1).jpeg',
        'WhatsApp Image 2022-06-30 at 10.37.02 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.39.10 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.39.11 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.39.12 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 10.55.06 PM.jpeg',
        'WhatsApp Image 2022-06-30 at 11.20.08 PM.jpeg',
    ],
    'Asia Square - 1': [
        'WhatsApp Image 2022-06-11 at 7.50.25 PM.jpeg',
        'WhatsApp Image 2022-06-01 at 12.45.01 PM (1).jpeg',
        'WhatsApp Image 2022-06-01 at 12.45.01 PM.jpeg',
        'WhatsApp Image 2022-06-01 at 12.45.02 PM.jpeg',
    ],
    'Asia Square - 2':[
        'WhatsApp Image 2022-06-11 at 11.23.59 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 11.24.00 PM.jpeg',
        'WhatsApp Image 2020-07-24 at 3.24.11 PM.jpeg',
        'WhatsApp Image 2020-07-24 at 3.24.13 PM.jpeg'
    ],
    '五育私塾': [
        'WhatsApp Image 2022-05-16 at 5.04.38 PM.jpeg',
    ],
    '35A Scotts Road 雪茄红酒吧私人会所':[
        'WhatsApp Image 2022-06-11 at 8.14.40 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 8.14.40 PM (2).jpeg',
        'WhatsApp Image 2022-06-11 at 8.14.40 PM (1).jpeg',
        'WhatsApp Image 2022-04-16 at 11.57.35 PM.jpeg',
        'WhatsApp Image 2022-05-16 at 5.05.49 PM.jpeg',
        'WhatsApp Image 2022-04-17 at 12.01.09 AM.jpeg',
        'WhatsApp Image 2022-04-17 at 12.03.44 AM.jpeg',
        'WhatsApp Image 2022-06-11 at 11.12.33 PM (1).jpeg',
        'WhatsApp Image 2022-06-11 at 11.12.33 PM.jpeg',
    ],
    'Four':[
        'WhatsApp Image 2022-03-27 at 2.51.54 PM (1).jpeg',
        'WhatsApp Image 2022-03-27 at 2.51.54 PM.jpeg',
    ],
    '南洋艺术学院轻歌剧“蝙蝠的复仇':[
        'WhatsApp Image 2022-06-11 at 8.18.13 PM.jpeg',
        '0c59e74863.jpeg',
        '4c58ce38db.jpeg',
        '081bf5cf32.jpeg',
    ],
    'Seven':[
        '9f6f72c3fe.jpeg',
        '54bd1664b6.jpeg',
        '89a1554c3b.jpeg',
        'b8a88274f3.jpeg',
    ],
    'Eight':[
        'be681b6061.jpeg',
        'fb7fe8e537.jpeg',
    ],
    'Nine':[
        'WhatsApp Image 2020-01-28 at 3.26.15 PM.jpeg',
        'WhatsApp Image 2020-01-28 at 3.26.16 PM (1).jpeg',
        'WhatsApp Image 2020-01-28 at 3.26.16 PM.jpeg',
        'WhatsApp Image 2020-01-28 at 3.26.17 PM.jpeg',
    ],
    'Ten':[
        'WhatsApp Image 2022-06-11 at 10.46.36 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.46.37 PM.jpeg',
        'WhatsApp Image 2020-02-18 at 1.49.10 PM.jpeg',
    ],
    'Suntec City - 1': [
        'WhatsApp Image 2022-06-11 at 8.13.05 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 8.13.04 PM.jpeg',
        '00013f24d3.jpeg',
        'b411ff0b82.jpeg',
    ],
    'Suntec City - 2':[
        'WhatsApp Image 2022-06-11 at 11.50.59 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 11.51.01 PM (1).jpeg',
        'WhatsApp Image 2022-06-11 at 11.51.01 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 11.51.02 PM (1).jpeg',
        'WhatsApp Image 2022-06-11 at 11.51.02 PM.jpeg',
    ],
    'Interior Design - 1':[
        'WhatsApp Image 2022-06-11 at 10.51.18 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.51.17 PM.jpeg',
        'WhatsApp Image 2022-03-27 at 2.39.06 PM.jpeg',
        'IMG-20201130-WA0001.jpg',
        'IMG-20201130-WA0002.jpg',
        'IMG-20201130-WA0003.jpg',
        'IMG-20201130-WA0004.jpg',
    ],
    'Interior Design - 2':[
        'WhatsApp Image 2022-03-27 at 2.39.06 PM (1).jpeg',
    ],
    'Interior Design - 3':[
        'WhatsApp Image 2022-06-11 at 7.53.16 PM.jpeg',
    ],
    'Interior Design - 4':[
        'WhatsApp Image 2022-06-11 at 10.03.12 PM.jpeg',
    ],
    'Interior Design - 5':[
        'WhatsApp Image 2022-06-11 at 10.03.13 PM (1).jpeg'
    ],
    'Interior Design - 6':[
        'WhatsApp Image 2022-06-11 at 10.03.12 PM (1).jpeg'
    ],
    'Fifteen':[
        'WhatsApp Image 2022-06-11 at 10.03.14 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.03.14 PM (1).jpeg',
        'WhatsApp Image 2022-06-11 at 10.03.15 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.03.15 PM (1).jpeg',
    ],
    'Nineteen':[
        'WhatsApp Image 2022-06-11 at 10.03.13 PM.jpeg'
    ],
    'Twenty':[
        'WhatsApp Image 2022-06-11 at 11.19.02 PM (1).jpeg',
        'WhatsApp Image 2022-06-11 at 11.19.02 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.48.58 PM (1).jpeg',
        'WhatsApp Image 2022-06-11 at 10.48.58 PM.jpeg',
    ],
    'Twenty One':[
        'WhatsApp Image 2022-06-11 at 11.17.19 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.50.23 PM.jpeg'
    ],
    'ST.约瑟夫机构私人拍卖会':[
        'WhatsApp Image 2022-06-11 at 10.53.49 PM.jpeg',
        'WhatsApp Image 2022-06-11 at 10.53.50 PM.jpeg',
    ],
};